module.exports = __webpack_public_path__ + "static/media/lobby_kingmakers.ad101fd6.ceef8acf.webp";